// client/src/components/ResetPasswordPage.js
import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { Container, TextField, Button, Typography, Alert, Box } from '@mui/material';
import AppBarHeader from './AppBarHeader';
import axiosInstance from '../axiosInstance';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    if (password.length < 10) {
      setError('Password must be at least 10 characters long.');
      return;
    }
    try {
      const token = searchParams.get('token');
      await axiosInstance.post('/auth/reset-password', { token, password });
      setSuccess('Password reset successfully.');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Reset failed. The link may have expired.');
    }
  };

  return (
    <div>
      <AppBarHeader />
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Typography variant="h5" gutterBottom>Reset Password</Typography>
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {!success && (
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth label="New Password" type="password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              required sx={{ mb: 2 }}
            />
            <TextField
              fullWidth label="Confirm New Password" type="password"
              value={confirm} onChange={(e) => setConfirm(e.target.value)}
              required sx={{ mb: 2 }}
            />
            <Button type="submit" variant="contained" fullWidth>Reset Password</Button>
          </Box>
        )}
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Button component={Link} to="/login" variant="text">Back to Login</Button>
        </Box>
      </Container>
    </div>
  );
}

export default ResetPasswordPage;
